import axios from "axios";
import {Message} from "element-ui";
import { Loading } from 'element-ui';
import router from "../router";
import hostUri from '../utils/registered_address'
// const baseURL='https://api.uplus100.fit/api'
const baseURL = process.env.NODE_ENV === 'development' ? '/api' : 'https://api.uplusai.info/api'
// const baseURL = 'https://api.uplusai.info/api'
// const baseURL='https://api.uplus666.work/api'
// const baseURL='http://47.84.186.185:9090/api'
// const baseURL='http://192.168.0.101:9090/api'
export const baseUrl=baseURL
var loading=''
let isFirstMessage=1
 function request(config){
  const instance=axios.create({
    baseURL,
    // baseURL:'http://localhost:8081/api',
    // baseURL:'http://192.168.0.105:9090/api',
    // baseURL:'http://192.168.0.6:9090/api',
    // baseURL:'http://localhost:8080/api',
    // baseURL:'http://8.214.96.149:8899/api',
    timeout:60000,
    headers:{
      'Content-Type': 'text/plain',
      //   'Content-Type': 'application/x-www-form-urlencoded',
      // 'Authorization': localStorage.getItem('token')!=null? localStorage.getItem('token') : ''
    },
      withCredentials:true
      // SameSite=None

  })
  instance.interceptors.request.use(config=>{
      const token = localStorage.getItem('token');
      if (token) {
          config.headers.Authorization = token
          if (process.env.NODE_ENV !== 'development') {
              config.params = config.params || {}
              config.params.token = config.params.token || token
          }
      }

      if (config.params && config.params.requestTimes == 10){

      } else{
          loading = Loading.service({
              lock: false,
              text: '加载中……',
              background: 'rgba(0, 0, 0, 0.7)'
          });
      }
      if (config.params) delete config.params.requestTimes
      setTimeout(()=>{
          if (loading && loading.close) loading.close()
      },10000)
    return config
  },err=>{
    console.log(err);
  })

  instance.interceptors.response.use(res=>{
      if (res.status==500) router.replace('/Server_error')
      if (res.status==404) router.replace('/Not_found')
      if (loading && loading.close) loading.close();
      if(res.data.toString().indexOf('not invalid token')!==-1) {
          console.log('qqqqqqqqqqqqq', isFirstMessage)
          var hostname = window.location.hostname
          if (hostUri.host_uri() == hostname) {
              router.push('/login')
              window.localStorage.removeItem('token')
              window.localStorage.removeItem('userInfo')
              return
          }
          if (isFirstMessage==1) {
              // router.replace('/login')
              window.localStorage.removeItem('token')
              // window.localStorage.removeItem(JSON.parse(localStorage.getItem('userInfo')).id+'\'1-1-1')
              window.localStorage.removeItem('userInfo')
              Message.warning('登录身份已过期,请重新登录 !')
              isFirstMessage++
              return;
          }
        return
      }else {
          if (window.localStorage.getItem('token'))
          isFirstMessage = 1
      }
    return res.data
  },err=>{
    console.log(err);
    if (err.message.includes('timeout')){
      Message({
        message:'服务器繁忙',
        type:'warning'
      })
    }
  })

  return  instance(config)

}
export default request
